import { render, staticRenderFns } from "./PersonBatchProfileHeader.vue?vue&type=template&id=3a67cc9a&scoped=true&"
import script from "./PersonBatchProfileHeader.vue?vue&type=script&lang=js&"
export * from "./PersonBatchProfileHeader.vue?vue&type=script&lang=js&"
import style0 from "./PersonBatchProfileHeader.vue?vue&type=style&index=0&id=3a67cc9a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a67cc9a",
  null
  
)

export default component.exports